import { getNumberId } from '../common/utils';

const initialize = () => {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  if (!window.SwymViewProducts) {
    window.SwymViewProducts = {};
  }
  if (!window.SwymProductVariants) {
    window.SwymProductVariants = {};
  }
  if (!window.SwymWishlist) {
    window.SwymWishlist = [];
  }
  window.SwymCallbacks.push(() => {
    _swat.fetch((products) => {
      window.SwymWishlist = products;
      products.forEach((product) => {
        window.SwymViewProducts[product.empi] = product;
        window.SwymProductVariants[product.epi] = product;
      });
      updateButtons();
    });
  });
};

const updateButtons = () => {
  document.querySelectorAll('.fs-wishlist-button').forEach((el) => el.classList.remove('added'));
  window.SwymWishlist.forEach((product) => {
    document.querySelectorAll(`.fs-wishlist-button[data-product-id="${product.empi}"]`).forEach((button) => {
      button.classList.add('added');
    });
  });
  document.querySelectorAll('.fs-wishlist-variant-button').forEach((el) => el.classList.remove('added'));
  window.SwymWishlist.forEach((product) => {
    const buttons = document.querySelectorAll(
      `.fs-wishlist-variant-button[data-product-id="${product.empi}"][data-variant-id="${product.epi}"]`,
    );
    buttons.forEach((button) => {
      button.classList.add('added');
    });
  });
};

const addShopifyProductToViewProducts = (product) => {
  const productId = getNumberId(product.id);
  const variantId = getNumberId(product.variants.nodes[0].id);
  if (window.SwymViewProducts[productId]) {
    return;
  }
  const productData = {
    empi: productId,
    epi: variantId,
    dt: product.title,
    du: `https://fashionsnap.store/products/${product.handle}?variant=${variantId}`,
    ct: product.productType,
    pr: parseInt(product.priceRange.minVariantPrice.amount),
    stk: product.totalInventory,
    iu: product.featuredImage ? product.featuredImage.url : '',
  };
  if (product.compareAtPriceRange && parseInt(product.compareAtPriceRange.minVariantPrice.amount)) {
    productData['op'] = parseInt(product.compareAtPriceRange.minVariantPrice.amount);
  }
  window.SwymViewProducts[productId] = productData;
};

const addAlgoliaProductToViewProducts = (product) => {
  if (window.SwymViewProducts[product.id]) {
    return;
  }
  const productData = {
    empi: product.id,
    epi: product.objectID,
    dt: product.title,
    du: `https://fashionsnap.store/products/${product.handle}?variant=${product.objectID}`,
    ct: product.product_type,
    pr: parseInt(product.price),
    stk: product.inventory_quantity,
    iu: product.image,
  };
  if (product.compare_at_price) {
    productData['op'] = product.compare_at_price;
  }
  window.SwymViewProducts[product.id] = productData;
};

const toggleWishlist = (productId) => {
  if (!window.SwymViewProducts[productId]) {
    return;
  }
  let product = window.SwymWishlist.find((product) => product.empi == productId);
  if (product) {
    _swat.removeFromWishList(product, (r) => {
      window.SwymWishlist = window.SwymWishlist.filter((p) => p.empi != product.empi);
      updateButtons();
    });
    return;
  }
  product = window.SwymViewProducts[productId];
  _swat.addToWishList(product, () => {
    window.SwymWishlist.push(product);
    updateButtons();
  });
};

const toggleWishlistWithVariantId = (productId, variantId, productHandle) => {
  if (!window.SwymViewProducts[productId]) {
    return;
  }
  let product = window.SwymWishlist.find((product) => product.empi == productId && product.epi == variantId);
  if (product) {
    _swat.removeFromWishList(product, (r) => {
      window.SwymWishlist = window.SwymWishlist.filter((p) => p.empi != product.empi || p.epi != product.epi);
      updateButtons();
    });
    return;
  }
  product = window.SwymViewProducts[productId];
  const params = {
    empi: productId,
    epi: variantId,
    dt: product.dt,
    du: `https://fashionsnap.store/products/${productHandle}?variant=${variantId}`,
    ct: product.ct,
    pr: product.pr,
    stk: product.stk,
    iu: product.iu,
  };
  _swat.addToWishList(params, (r) => {
    window.SwymWishlist.push(r);
    updateButtons();
  });
};

const Wishlist = () => {
  return {
    initialize: initialize,
    updateButtons: updateButtons,
    addShopifyProductToViewProducts: addShopifyProductToViewProducts,
    addAlgoliaProductToViewProducts: addAlgoliaProductToViewProducts,
    toggleWishlist: toggleWishlist,
    toggleWishlistWithVariantId: toggleWishlistWithVariantId,
  };
};

export default Wishlist;
